
import { ArtistModel } from '@/models'
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class ArtistSearch extends Vue {
    @Prop()
    artists !: ArtistModel[]
    @Prop({default: false})
    more !: boolean

}
